<script setup lang="ts">
import { ref } from "vue";
import IconComponent from "../common/IconComponent.vue";
defineProps<{
  icon: string;
  name?: string;
  title?: string;
  tooltip?: {
    title?: string;
    description: string;
    type?: "info" | "error" | "warning";
  };
  type?:
    | "primary"
    | "warning"
    | "danger"
    | "success"
    | "info"
    | "secondary"
    | undefined;
}>();

defineEmits<{
  (e: "click"): void;
}>();

const getColor = (variant: string) => {
  switch (variant) {
    case "danger":
      return "text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-100";
    case "primary":
      return "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100";
    case "info":
      return "text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-100";
    case "secondary":
      return "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-100";
    case "success":
      return "text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-100";
    case "warning":
      return "text-yellow-600 dark:text-yellow-400 hover:bg-yellow-100 dark:hover:bg-yellow-100";
    default:
      return "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-100";
  }
};

//const tooltipPosition = ref<{ x: number; y: number }>({ x: 0, y: 0 });
const displayToolTip = ref(false);
const iconButtonTooltip = ref<HTMLElement | null>(null);

/*const tooltipClass = computed(() => {
  return {
    "tooltip-info": props.tooltip?.type === "info" || !props.tooltip?.type,
    "tooltip-error": props.tooltip?.type === "error",
    "tooltip-warning": props.tooltip?.type === "warning",
  };
});*

/*const tooltipStyle = computed(() => {
  return {
    top: tooltipPosition.value.y + "px",
    left: tooltipPosition.value.x + "px",
  };
});*/

const dropdownTop = ref(0);
  const dropdownRight = ref<number | null>(null);
  const dropdownLeft = ref<number | null>(null);

const showTooltip = (event: {
  target: any;
  clientX: number;
  clientY: number;
}) => {
  const button = event.target;
  displayToolTip.value = true;
  //iconButtonTooltip.value = document.getElementById("iconButtonTooltip");
  if (iconButtonTooltip.value) {
    const buttonRect = button.getBoundingClientRect();
    dropdownTop.value = button.bottom; // Position dropdown below the button
  if (window.innerWidth - buttonRect.right > 200) { // 200 is an arbitrary value to check if there's enough space
      dropdownLeft.value = buttonRect.left; // Align dropdown to the left of the button
      dropdownRight.value = null;
    } else {
      dropdownRight.value = window.innerWidth - buttonRect.right; // Align dropdown to the right of the button
      dropdownLeft.value = null;
    }    
    displayToolTip.value = true;
  }
};
</script>
<template>
    <button
      @mouseover="showTooltip"
      @mouseleave="displayToolTip = true"
      :key="name"
      :id="'table-action-' + name"
      @click="$emit('click')"
      :class="[getColor(type || 'primary')]"
      :title="title"
    >
      <IconComponent :name="icon" />
    </button>
</template>
<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: fixed;
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  font-size: 14px;
  z-index: 99999999 !important; /* Increased z-index to ensure tooltip is above sticky elements */
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.tooltip-title {
  font-weight: bold;
}

.tooltip-separator {
  margin: 5px 0;
  border: none;
  border-top: 1px solid #eaeaea;
}

.tooltip-description {
  font-size: 12px;
}

.tooltip-info {
  background-color: #2196F3;
}

.tooltip-error {
  background-color: #F44336;
}

.tooltip-warning {
  background-color: #FFC107;
}
</style>